export default {
    "aws_user_pools_web_client_id":"tcrutcet5202ts7jp58ce5583",
    Cognito:{

    Auth: {
        Cognito: {
                userPoolClientId: 'tcrutcet5202ts7jp58ce5583',
                userPoolId: 'us-east-1_GM9NMp6Tp',

        }
    }
    }
}